import React, { FC } from 'react';

import { Button } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { SettingPageLayout } from 'client/blocks/Layout/Layout';
import { getIsYangoRequest } from 'client/utils';
import * as keyset from 'i18n/TwoFaRequired';

import styles from './TwoFaRequiredScreen.module.scss';

const t = i18n(keyset);

const ENABLE_2FA_URL = 'https://id.yandex.ru/security/enter-methods';
const ENABLE_2FA_URL_YANGO = 'https://id.yango.com/security/enter-methods';

/**
 * Блок-экран для пользователей без 2FA. Рендерится в SettingPageLayout → переиспользует шапку
 * приложения (логотип, тему, passport-виджет). Включается гейтом в App.tsx.
 */
export const TwoFaRequiredScreen: FC = () => {
    const isYango = getIsYangoRequest();
    const enable2faUrl = isYango ? ENABLE_2FA_URL_YANGO : ENABLE_2FA_URL;
    const enable2faLabel = t(isYango ? 'two-fa-required-button-yango' : 'two-fa-required-button');

    return (
        <SettingPageLayout>
            <div className={styles.container}>
                <div className={styles.card} role="alert">
                    <h1 className={styles.title}>{t('two-fa-required-title')}</h1>
                    <p className={styles.text}>{t('two-fa-required-description')}</p>
                    <p className={styles.text}>{t('two-fa-required-how-to')}</p>
                    <div className={styles.actions}>
                        <Button view="action" size="l" href={enable2faUrl} target="_blank" rel="noopener noreferrer">
                            {enable2faLabel}
                        </Button>
                        <Button view="normal" size="l" onClick={() => window.location.reload()}>
                            {t('two-fa-required-refresh')}
                        </Button>
                    </div>
                    <p className={styles.hint}>{t('two-fa-required-hint')}</p>
                </div>
            </div>
        </SettingPageLayout>
    );
};
